import { Component } from 'react'
import { observer } from 'mobx-react'

import * as h from 'h'
import { filterRequestsByNamespace } from 'utils'

import { PopoutTransitionContainer } from 'components/Popout/PopoutTransitionContainer'
import SearchBar from 'components/SearchBar'
import Results from 'components/Results'

@observer(['UiStore', 'ResourceStore'])
export default class Resources extends Component {
  // --------------------------------------------------------------------------
  // Lifecycle
  // --------------------------------------------------------------------------

  componentWillMount () {
    const { UiStore, location } = this.props

    if (Object.keys(location.query).length === 0) {
      UiStore.resetResourceFilters()
      UiStore.updateResourceFiltersInUrlBar()
    } else {
      UiStore.updateResourceFiltersInUiStoreFromUrl(location.query)
    }
  }

  componentDidMount () {
    this.props.ResourceStore.startFetcher()
  }

  componentWillUnmount () {
    this.props.ResourceStore.stopFetcher()
  }

  componentWillReceiveProps (newProps) {
    const goingIntoPopout = newProps.location.pathname.match(/\/resource\/.*/)

    // Going into a popout changes the URL. If we update, we will have no types.
    if (!goingIntoPopout) {
      this.props.UiStore.updateResourceFiltersInUiStoreFromUrl(newProps.location.query)
    }
  }

  // --------------------------------------------------------------------------
  // Helpers
  // --------------------------------------------------------------------------

  get resources () {
    const { ResourceStore: { resources } } = this.props

    return resources
  }

  get isRequesting () {
    return filterRequestsByNamespace(this.props.UiStore.requests, 'resource').length > 0
  }

  // --------------------------------------------------------------------------
  // Render
  // --------------------------------------------------------------------------

  render () {
    const { UiStore } = this.props
    const { resourceFilters } = UiStore

    return h.div(null,
      h.h(PopoutTransitionContainer, null, this.props.children),
      h.h(SearchBar, {
        value: resourceFilters.search,
        onChange: value => {
          resourceFilters.search = value
        }
      }),
      h.div(h.ca('gimme-10')),
      h.h(Results, {
        elements: this.resources,
        isRequesting: this.isRequesting,
        onPageClick: () => null
      }))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Resources/index.js